module.exports = __webpack_public_path__ + "img/43_55.e60301b1.png";